import React from "react";
import { Drawer } from "antd";
import { FaChair } from "react-icons/fa";
import { MdOutlineLunchDining } from "react-icons/md";
import { BsPeopleFill } from "react-icons/bs";
import { PiBookOpenDuotone, PiNotepadDuotone } from "react-icons/pi";
import { CgSandClock } from "react-icons/cg";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { IoIosLogOut, IoIosSettings } from "react-icons/io";
const MenuDrawer = ({ open, setOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <Drawer
      closable={false}
      width={300}
      open={open}
      placement="left"
      className="text-dynmaicText"
      onClose={() => setOpen(false)}
    >
      <div>
        <div className="flex flex-col justify-start items-center gap-8 mt-4 text-lg">
     
          <NavLink to={"/makeorder"} className={"w-full"}>
            <p
              onClick={() => setOpen(false)}
              className={`flex ${
                location?.pathname === "/makeorder" && "text-brand w-full"
              } hover:text-brand transition-all w-full cursor-pointer justify-start items-center gap-2`}
            >
              <FaChair color="gray" /> Create Order
            </p>
          </NavLink>
          <NavLink to={"/menus"} className="w-full">
            <p
              onClick={() => setOpen(false)}
              className={`flex ${
                location?.pathname === "/menus" && "text-brand w-full"
              } hover:text-brand transition-all w-full cursor-pointer justify-start items-center gap-2`}
            >
              <MdOutlineLunchDining color="gray" />
              Items
            </p>
          </NavLink>
          <NavLink to={"/staff"} className="w-full">
            <p
              onClick={() => setOpen(false)}
              className={`flex ${
                location?.pathname === "/staff" && "text-brand w-full"
              } hover:text-brand transition-all w-full cursor-pointer justify-start items-center gap-2`}
            >
              <BsPeopleFill color="gray" />
              People
            </p>
          </NavLink>
          <NavLink to={"/sales"} className="w-full">
            <p
              onClick={() => setOpen(false)}
              className={`flex ${
                location?.pathname === "/sales" && "text-brand w-full"
              } hover:text-brand transition-all w-full cursor-pointer justify-start items-center gap-2`}
            >
              <PiBookOpenDuotone color="gray" />
              Sales
            </p>
          </NavLink>
          <NavLink className={"w-full"} to={"/orders"}>
            <p
              onClick={() => setOpen(false)}
              className={`flex ${
                location?.pathname === "/orders" && "text-brand w-full"
              } hover:text-brand transition-all w-full cursor-pointer justify-start items-center gap-2`}
            >
              <CgSandClock color="gray" />
              Orders
            </p>
          </NavLink>
          <NavLink to={"/order-status"} className={"w-full"}>
            <p
              onClick={() => setOpen(false)}
              className={`flex ${
                location?.pathname === "/order-status" && "text-brand w-full"
              } hover:text-brand transition-all w-full cursor-pointer justify-start items-center gap-2`}
            >
              <PiNotepadDuotone color="gray" /> Status
            </p>
          </NavLink>
          <NavLink className={"w-full"} to={"/setting"}>
            <p
             onClick={() => setOpen(false)}
              className={`flex ${
                location?.pathname === "/setting" && "text-brand"
              } hover:text-brand transition-all cursor-pointer justify-start items-center gap-2`}
            >
              <IoIosSettings color="gray" />
              Setting
            </p>
          </NavLink>
          <p
            onClick={() => {
              localStorage.clear();
              navigate("/");
            }}
            className={`flex text-xs text-start  bg-brand text-dynmaicText rounded-full px-4 py-2 transition-all cursor-pointer justify-start items-start gap-2`}
          >
            LogOut
            <IoIosLogOut color="white" />
          </p>
        </div>
      </div>
    </Drawer>
  );
};

export default MenuDrawer;
